import { IPerson as IAaNgPerson } from 'aa-ng';

import { DesiredExposure } from './enums';
import { IInstitution } from './institution';
import { IUnit } from './unit';

export interface IPerson {
  id: number;
  aaId?: number;
  firstName: string;
  lastName: string;
  middleName: string;
  primaryUnitAffiliation?: IUnit;
  nonPrimaryUnitAffiliations?: IUnit[];
  primaryInstitution: IInstitution;
  desiredExposure: DesiredExposure;
  isNonFaculty: boolean;
  degreeYear?: number;
  hasPreferredName?: boolean;
  isMatchVerificationComplete?: boolean;
}

export function mapPerson(person: IPerson): IAaNgPerson {
  return {
    ...person,
    unitName: person.primaryUnitAffiliation?.name,
    relevantCollaborativeWorksCount: 0,
    relevantWorksCount: 0,
    title: '',
  } as IAaNgPerson;
}
